import { ITipsManager, ITipsManagerInjectable } from '@src/slide/application/service/tips-manager/core/tips-manager.interface';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

export class TipsManagerInjectable implements ITipsManagerInjectable {
    public showCannotCopyTips?: (manager: ITipsManager) => void;
    public showBrowserNotSupport?: (manager: ITipsManager) => void;
    public showCannotEditTips(): boolean {
        return !ENV.IS_LOCAL_EDIT;
    }
}
